import { useQuery } from 'react-query';
import {
    GetCustomerDashboardStats,
    GetCustomersStats,
    GetRentBreakdown,
    GetSecurityBreakdown,
    GetStats,
    GetTeamMemberDashboardStats,
} from '../services/backend';
import { NotifyError } from '../utils/functions';

export function useGetStats() {
    return useQuery('stats', GetStats, {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch stats", error);
            console.error("Error fetching stats:", error);
        }
    });
}

export function useGetCustomerDashboardStats() {
    return useQuery('customer-dashboard-stats', GetCustomerDashboardStats, {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch customer dashboard stats", error);
            console.error("Error fetching customer dashboard stats:", error);
        }
    });
}

export function useGetTeamMemberDashboardStats() {
    return useQuery(['team-member-dashboard-stats'], () => GetTeamMemberDashboardStats(), {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || {};
        },
        onError: (error) => {
            NotifyError("Failed to fetch team member dashboard stats", error);
            console.error("Error fetching team member dashboard stats:", error);
        }
    });
}

export function useGetRentBreakdown() {
    return useQuery('rent-breakdown', GetRentBreakdown, {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch rent breakdown", error);
            console.error("Error fetching rent breakdown:", error);
        }
    });
}

export function useGetSecurityBreakdown() {
    return useQuery('security-breakdown', GetSecurityBreakdown, {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch security breakdown", error);
            console.error("Error fetching security breakdown:", error);
        }
    });
}

export function useGetCustomersStats() {
    return useQuery('customers-stats', GetCustomersStats, {
        staleTime: 0,
        cacheTime: 0,
        select: (data) => {
            return data?.data?.stats || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch customers stats", error);
            console.error("Error fetching customers stats:", error);
        }
    });
}